import {
  ALERT_METRIC,
  CLEAR_ALERT_METRIC,
} from "../common/reducers/MetricReducer";

/**
 * Dispatches alert information for metrics based on work item alerts
 * @param {Object} allMetricData - Object containing all metric data keyed by metric name
 * @param {Object} workItemAlerts - Object containing work item alerts
 * @param {Function} dispatch - Redux dispatch function
 */
export const addAlertInfoToMetrics = (
  allMetricData,
  workItemAlerts,
  dispatch,
) => {
  if (
    !workItemAlerts ||
    !workItemAlerts.alerts ||
    !Array.isArray(workItemAlerts.alerts)
  ) {
    return;
  }

  const alertMetricNames = new Set(
    workItemAlerts.alerts.map((alert) => alert.metricName).filter(Boolean),
  );

  // Create a mapping of metric names to their roles (can be multiple roles per metric)
  const metricRoleMap = workItemAlerts.alerts.reduce((map, alert) => {
    if (alert.metricName && Array.isArray(alert.roles)) {
      map[alert.metricName] = map[alert.metricName]
        ? [...new Set([...map[alert.metricName], ...alert.roles])]
        : [...alert.roles];
    }
    return map;
  }, {});

  Object.keys(allMetricData).forEach((metricName) => {
    const metric = allMetricData[metricName];
    const isInAlerts = alertMetricNames.has(metricName);
    const wasInAlert = metric && metric.alert && metric.alert.isInAlert;

    if (isInAlerts && !wasInAlert) {
      dispatch({
        type: ALERT_METRIC,
        metricId: metricName,
        roles: metricRoleMap[metricName] || [],
      });
    } else if (!isInAlerts && wasInAlert) {
      dispatch({
        type: CLEAR_ALERT_METRIC,
        metricId: metricName,
      });
    }
  });
};



// WEBPACK FOOTER //
// ./src/components/mySCC/util/AlertingUtils.js